/** Robot Cargo: `robot` (до подъезда) и `robot_d2d` (до двери). */
export function isRobotYandexDeliveryType(yandexDeliveryType: string | null | undefined): boolean {
  return yandexDeliveryType === 'robot' || yandexDeliveryType === 'robot_d2d'
}
